import type {AxiosRequestConfig} from 'axios';
import {Product} from './interface';

export class SubmitProductInfo {
  private productsRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/products/status',
  };
  data(body: any) {
    this.productsRequest.data = body;
    return this;
  }
  id(id: number) {
    this.productsRequest.url = `/products/${id}/status`;
    return this;
  }
  build() {
    return this.productsRequest;
  }
}

export class DeleteProductBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.productsRequest.url = `/products/${id}`;
    return this;
  }
  build() {
    return this.productsRequest;
  }
}

export class DeleteVariantsBuilder {
  private readonly variantsRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };

  id(id: number) {
    this.variantsRequest.url = `/variants/${id}`;
    return this;
  }

  build() {
    return this.variantsRequest;
  }
}
export class GetAllProductsRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/products',
    params: {},
  };

  id(id: number) {
    this.productsRequest.url = `/products/${id}`;
    return this;
  }
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}
export class GetAllVitrinProductsRequestBuilder {
  private readonly vitrinProductsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/products/selected',
    params: {},
  };
  params(params: object) {
    this.vitrinProductsRequest.params = params;
    return this;
  }

  build() {
    return this.vitrinProductsRequest;
  }
}

export class GetVariantsRequestBuilder {
  private readonly variantRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/skus',
    params: {},
  };

  id(id: number) {
    this.variantRequest.url = `/skus/${id}`;
    return this;
  }
  params(params: object) {
    this.variantRequest.params = params;
    return this;
  }

  build() {
    return this.variantRequest;
  }
}

export class UpdateVariantRequestBuilder {
  private readonly variantRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/skus',
    params: {},
  };

  data(body: any) {
    this.variantRequest.data = body;
    return this;
  }

  build() {
    return this.variantRequest;
  }
}

export class GetProductsCountRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/products/count',
    params: {},
  };
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class GetCategoriesRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/product-categories',
    params: {},
  };
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class GetPartnerCategoriesRequestBuilder {
  private readonly Request: AxiosRequestConfig = {
    method: 'GET',
    url: '/categories',
    params: {},
  };
  params(params: object) {
    this.Request.params = params;
    return this;
  }

  build() {
    return this.Request;
  }
}

export class GetProductsInventoryRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  };

  id(id: number) {
    this.productsRequest.url = `/products/${id}/inventory`;
    return this;
  }
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class GetProductsVariantRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  };

  id(id: number) {
    this.productsRequest.url = `/skus/with-stock?productId.equals=${id ?? ''}`;
    return this;
  }
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class GetProductsVariantInventoryItemsRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/inventory-items',
    params: {},
  };

  id(id: number) {
    this.productsRequest.url = `/inventory-items/${id}`;
    return this;
  }
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class CreateProductRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/products',
    data: {},
  };

  data(data: Product) {
    this.productsRequest.data = data;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class UpdateProductRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/products',
    data: {},
  };
  id(id: number) {
    this.productsRequest.url = `/products/${id}/admin`;
    return this;
  }
  data(body: Product | number) {
    this.productsRequest.data = body;
    return this;
  }
  build() {
    return this.productsRequest;
  }
}

export class CreateProduct {
  private readonly request: AxiosRequestConfig = {
    method: 'POST',
    url: '/products',
    data: {},
  };

  data(data: any) {
    this.request.data = data;
    return this;
  }

  build() {
    return this.request;
  }
}

export class UploadImageRequestBuilder {
  private readonly productRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/orders/new',
    data: {},
  };

  id(id: number) {
    this.productRequest.url = `/products/${id}/upload-image`;
    return this;
  }

  data(data: any) {
    this.productRequest.data = data;
    return this;
  }

  build() {
    return this.productRequest;
  }
}

export class CreatePartnerCategoryBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'POST',
    url: '/categories',
    data: {},
  };

  data(data: any) {
    this.request.data = data;
    return this;
  }

  build() {
    return this.request;
  }
}

export class GetPartnerCategoriesBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/categories',
    params: {},
  };
  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class UploadProductsRequestBuilder {
  private readonly uploadProductsReq: AxiosRequestConfig = {
    method: 'POST',
    url: '/products/uploadFile',
    data: {},
  };

  data(body: any) {
    this.uploadProductsReq.data = body;
    return this;
  }

  build() {
    return this.uploadProductsReq;
  }
}

export class UploadUpdateProductsRequestBuilder {
  private readonly uploadProductsReq: AxiosRequestConfig = {
    method: 'PUT',
    url: '/products/uploadFile',
    data: {},
  };

  data(body: any) {
    this.uploadProductsReq.data = body;
    return this;
  }

  build() {
    return this.uploadProductsReq;
  }
}

export class GetVitrinCategories {
  private readonly getCategories: AxiosRequestConfig = {
    method: 'GET',
    url: '/categories',
  };

  build() {
    return this.getCategories;
  }
}

export class CreateVitrinProduct {
  private readonly createProduct: AxiosRequestConfig = {
    method: 'POST',
    url: '/products',
    data: {},
  };

  data(body: any) {
    this.createProduct.data = body;
    return this;
  }

  build() {
    return this.createProduct;
  }
}

export class SelectVitrinProduct {
  private readonly createProduct: AxiosRequestConfig = {
    method: 'POST',
    url: '/products',
    data: {},
  };

  id(id: any) {
    this.createProduct.url = `/products/${id}/select`;
    return this;
  }

  build() {
    return this.createProduct;
  }
}

export class UnSelectVitrinProduct {
  private readonly createProduct: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/products',
    data: {},
  };

  id(id: any) {
    this.createProduct.url = `/products/${id}/un-select`;
    return this;
  }

  build() {
    return this.createProduct;
  }
}

export class UpdateVitrinProduct {
  private readonly updateProduct: AxiosRequestConfig = {
    method: 'PUT',
    url: '/products',
    data: {},
  };

  id(id: string) {
    this.updateProduct.url = `/products/${id}`;
    return this;
  }

  data(body: any) {
    this.updateProduct.data = body;
    return this;
  }

  build() {
    return this.updateProduct;
  }
}

export class RemoveVitrinProduct {
  private readonly removeProduct: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/products',
  };

  id(id: string) {
    this.removeProduct.url = `/products/${id}`;
    return this;
  }

  build() {
    return this.removeProduct;
  }
}

export class GetVitrinProduct {
  private readonly getProduct: AxiosRequestConfig = {
    method: 'GET',
    url: '/products',
    params: {},
  };

  params(params: any) {
    this.getProduct.params = params;
    return this;
  }

  build() {
    return this.getProduct;
  }
}

export class GetVitrinProductCount {
  private readonly getProduct: AxiosRequestConfig = {
    method: 'GET',
    url: '/products/count',
    params: {},
  };

  params(params: any) {
    this.getProduct.params = params;
    return this;
  }

  build() {
    return this.getProduct;
  }
}

export class GetVitrinSelectedProducts {
  private readonly getProduct: AxiosRequestConfig = {
    method: 'GET',
    url: '/products/selected',
    params: {},
  };

  params(params: any) {
    this.getProduct.params = params;
    return this;
  }

  build() {
    return this.getProduct;
  }
}

export class GetVitrinSelectedProductsCount {
  private readonly getProduct: AxiosRequestConfig = {
    method: 'GET',
    url: '/products/selected/count',
    params: {},
  };

  params(params: any) {
    this.getProduct.params = params;
    return this;
  }

  build() {
    return this.getProduct;
  }
}

export class GetVitrinProductById {
  private readonly getProduct: AxiosRequestConfig = {
    method: 'GET',
    url: '/products',
  };

  id(id: any) {
    this.getProduct.url = `/products/${id}`;
    return this;
  }

  build() {
    return this.getProduct;
  }
}

export class UploadImage {
  private readonly uploadProduct: AxiosRequestConfig = {
    method: 'PUT',
    url: '/products/image',
    data: {},
  };

  id(id: number) {
    this.uploadProduct.url = `/products/${id}/images`;
    return this;
  }

  data(data: any) {
    this.uploadProduct.data = data;
    return this;
  }

  build() {
    return this.uploadProduct;
  }
}

export class GetImage {
  private readonly uploadProduct: AxiosRequestConfig = {
    method: 'GET',
    url: '/products/image',
  };

  id(id: number, fileName: string) {
    this.uploadProduct.url = `/products/${id}/images/${fileName}`;
    return this;
  }

  build() {
    return this.uploadProduct;
  }
}

export class RemoveImage {
  private readonly removeImage: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/products/image',
  };

  id(id: number, fileName: string) {
    this.removeImage.url = `/products/${id}/images/${fileName}`;
    return this;
  }

  build() {
    return this.removeImage;
  }
}
